<form [formGroup]="matrixModifyFormGroup" *ngIf="matrixModifyFormGroup">
    <mat-icon *ngIf="isMatrixEditable">
        <a href="javascript:void(0)" (click)="open(mymodal_edit)" #tooltip="matTooltip" matTooltip="Edit" [matTooltipPosition]="tooltip_position">edit</a>
    </mat-icon>

    <!-- edit modal open -->
    <ng-template #mymodal_edit let-modal>
        <div class="modal-header">
            <h4>Edit Joint Matrix Name</h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')">
                <i class="flaticon2-cross"></i>
            </a>
        </div>
        <div class="modal-body output-lable">
            <div class="row">
                <div class="col-md-3" style="padding: 15px">
                    <mat-label class="font-style">Name</mat-label>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="example-full-width custom-text-field">
                        <input
                            type="text"
                            matInput
                            placeholder="New Name Here"
                            formControlName="matrixNewName"
                            name="name"
                            #tooltip="matTooltip"
                            matTooltip="Matrix Name is Required"
                            [matTooltipDisabled]="matrixModifyFormGroup.get('matrixNewName').valid"
                             (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn primary-ebtn" (click)="updateMatrixName()">Ok</button>
            <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
        </div>
    </ng-template>
</form>
